const formModals = {
    init() {
        $(document).on('click', 'a[href*="form."]', (event) => {
            event.preventDefault();
            const formID = $(event.currentTarget).attr('href').split('.')[1];
            $.get(
                window.wp_js.ajax_url,
                {
                    action: 'load_form',
                    form_id: formID,
                },
                (response) => {
                    $('#formModal .modal-body').html(response);
                    $(document).trigger('gform_post_render');
                    $('#formModal').modal('show');
                },
            );
        });
    },
};

export default formModals;
